import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { cn } from '../../lib/utils';

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  placeholderSrc?: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className,
  width,
  height,
  placeholderSrc
}) => {
  const [isError, setIsError] = useState(false);
  
  // Default placeholder for when image fails to load
  const defaultPlaceholder = `https://via.placeholder.com/400x225?text=${encodeURIComponent(alt || 'Image')}`;
  
  // Use provided placeholder or default
  const actualPlaceholder = placeholderSrc || defaultPlaceholder;
  
  return (
    <LazyLoadImage
      alt={alt}
      src={isError ? defaultPlaceholder : src}
      effect="blur"
      className={cn("transition-opacity duration-300", className)}
      width={width}
      height={height}
      onError={() => setIsError(true)}
      placeholderSrc={actualPlaceholder}
      threshold={200} // Start loading when 200px from viewport
    />
  );
};

export default LazyImage;